<template lang="pug">
  tr.row
    td.col.mark(:colspan=2)
      CompanyTableMark(
        :company="company", @update="update", :updateMarkForIndex="updateMarkForIndex"
      )
      p(v-if="company.job_mark_user") {{ company.job_mark_user }}
    td.col.check
      label.checkbox
        input(
          type="checkbox",
          :value="company.id",
          :checked='checked',
          :disabled="isGlobalLocked",
          @click="check($event, company.id)"
        )
    td.col(v-for="v in columns", v-if="displayedColumns.includes(v.key)", :class="v.key")
      template(v-if="v.url")
        a(
          :href="company[v.key]"
          target="_blank"
          rel="noopener noreferrer"
        ) {{ company[v.key] }}
      template(v-else-if="v.multiple")
        span(v-for="c in company[v.key]")
          | {{ c }}
          br
      template(v-else-if="v.masterUrl")
        a(:href="company[v.key]" target="_blank" rel="noopener noreferrer") 求人一覧
      template(v-else)
        span.only-sp(v-if="v.spLabel") {{ v.spLabel }}
        router-link(v-if="v.detail", :to="{ name: 'CompanyDetail', query: { id: company.id } }", target="_blank") {{ company[v.key] }}
        span(v-else) {{ company[v.key] }}
        a(
          v-if="exclusionCompanyName && v.key === 'company_name'",
          :class="company.hidden ? 'hidden on' : 'hidden'"
          @click="hideCompany(company.hidden, company.id, company['company_name'])"
        )
          i.fa.fa-eye-slash
    td.col(v-if="leadManagementShareButton")
      template(v-if="company.is_account")
        span.only-sp 取引先追加
        span ✓
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex'
  import CompanyTableMark from './CompanyTableMark'

  export default {
    components: { CompanyTableMark },
    props: ['company', 'modal', 'checkedIds', 'updateMarkForIndex', 'leadManagementShareButton', 'exclusionCompanyName'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      ...mapState({
        columns: state => state.companyTableConfiguration.columns,
        displayedColumns: state => state.companyTableConfiguration.displayedColumns,
      }),
      checked () {
        return this.checkedIds.has(this.company.id)
      },
    },
    methods: {
      ...mapMutations('company', ['clearDetail']),
      check (event, id) {
        event.preventDefault()
        const checked = event.currentTarget.checked
        this.$emit('check', { checked, id })
      },
      openDetailPage (e) {
        e.stopPropagation()
        this.$router.push({ name: 'CompanyDetail', query: { id: this.company.id } })
      },
      update () {
        this.clearDetail()
        this.$emit('update', { id: this.company.id })
      },
      hideCompany (hidden, id, name) {
        if (hidden) {
          this.$router.push({ name: 'ExclusionCompanyName' })
        } else {
          const companyName = name.replace(/&amp;/g, '&')
          this.$emit('hideCompany', { id, companyName })
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CompanyTableRow.vue